export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/theme-mixins/DataGridResults.js